import '@/styles/main.css'
import * as Sentry from '@sentry/vue'
import { createApp } from 'vue'

import App from './App'
import auth from './plugins/auth'
import customIconify from './plugins/custom-iconify'
import router from './router'

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://310481016aa248e935986e494482820d@sentry.backyard.in.th/2',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false
    })
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['https://arm.backyard.in.th'],
  allowUrls: ['https://arm.backyard.in.th'],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

app.use(auth)
app.use(customIconify)
app.use(router)
app.mount('#app')
